import React from 'react';
import academic_life from '../../assests/img/academic-life.jpg';

const AcademicLife = () => {

    return (
        <>
            <div className='inner_top_about_us'>
                <div id="bg" className="data-typography-1 data-theme-1">
                    <div className="page-wraper">
                        <div className="page-content bg-white">
                            <div className="dz-bnr-inr dz-bnr-inr-sm style-1 text-center overlay-primary-dark">
                                <div className="coustom_container">
                                    <div className="dz-bnr-inr-entry">
                                        <div className="pheading">
                                            <h1>Academic Life</h1>
                                        </div>
                                        <nav aria-label="breadcrumb" className="breadcrumb-row">
                                            <ul className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <a href="/">Home</a>
                                                </li>
                                                <li className="mx-2">
                                                    /
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    Academic Life
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>


                            <section className="content-inner section-wrapper5 pt-5 pb-5">
                                <div className="container">
                                    <div className="row">
                                        <div
                                            className="col-xl-9 col-lg-6 m-b30 wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <div id="pagedata" className="pagedata">
                                                <p style={{ textAlign: "justify" }}>
                                                    <img src={academic_life} alt="academic-life" width="100%" />
                                                </p>
                                                <p style={{ textAlign: "justify" }}>
                                                    Our aim at Karamchand Memorial School is to enable pupils to be the best that they can be in a lively, stimulating and rewarding environment. We provide a rounded education in which academic, physical, creative, social, moral and spiritual elements are intrinsic and important parts. Alongside subject-based learning, our younger pupils spend some time outside the classroom learning under the blue sky with mother earth under their bare feet and their hands curiously combing through the hidden mysteries around them. Whilst pursuing high academic standards, the school takes seriously its role in developing personal and social skills, and an understanding of the world beyond school.
                                                </p>
                                                <p style={{ textAlign: "justify" }}>
                                                    Although we are guided by the National Education Policy in our academic planning, we are not restricted to it. The teaching staff at Karamchand Memorial School are highly qualified, engaging and inspiring subject specialists who’ll routinely plan for our pupils to go broader and deeper than NEP stipulate. Opportunities to enrich the curriculum through trips, workshops, extracurricular and interdisciplinary projects will be actively sought and planned for.
                                                </p>
                                                <p style={{ textAlign: "justify" }}>
                                                    We aim for our pupils to be extremely successful in a wide variety of academic pursuits. We believe pupils learn best when they are actively involved in lessons, discovering, questioning and understanding the subject matter for themselves. We encourage pupils to think creatively and critically. For our pupils, the curriculum is just the start. We want them to be fascinated by the process of discovery.
                                                </p>
                                            </div>
                                        </div>

                                        <div
                                            className="col-xl-3 col-lg-6 wow fadeInUp"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="bg-lgrey">
                                                <div className="subMenubg active">
                                                    <a href="spiritual-care-and-wellbeing" target="_self" className="submenu">
                                                        Spiritual care and Wellbeing
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="academic-life"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Academic Life
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="sporting-life" target="_self" className="submenu">
                                                        Sporting Life
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="co-curricular" className="submenu">
                                                        Co-curricular
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="social-responsibility" target="_self" className="submenu">
                                                        Social Responsibility
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="activities"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Activities
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="amenities"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Amenities
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                        {/* <button className="scroltop icon-up" type="button">
                            <i className="fas fa-arrow-up"></i>
                        </button> */}
                    </div>
                </div>
            </div >
        </>
    )
}

export default AcademicLife;